import { init } from "@outschool/experiments-shared";

import {
  clientVersion,
  COMMIT_SHA,
  EVENT_TRACKING_ENDPOINT,
  OUTSCHOOL_ENV,
} from "../../shared/Env";

export function initExperiments() {
  init({
    GIT_COMMIT_SHA: COMMIT_SHA as string,
    EVENT_TRACKING_ENDPOINT,
    OUTSCHOOL_ENV,
    CLIENT_VERSION: clientVersion,
  });
}
